import React, { useState } from 'react';
import { Field, useField } from 'react-final-form';
import { useTranslation } from 'react-i18next';

import WithLabel, { LABEL_STYLES } from '../../../components/with-label/WithLabel';
import WithError from '../../../components/with-error/WithError';
import Icon from '../../../icons/Icon';
import { ICONS } from '../../../icons';
import ImagePreview from '../../../id8/components/recreate/upload-modal/ImagePreview';
import DropZone from '../../../components/chat-input/components/drop-zone/DropZone';

import scss from './FileInput.module.scss';

function FileInput({ name, label, isRequired, acceptedFileTypes, disabled }) {
  const { t } = useTranslation('studio');
  const [previewError, setPreviewError] = useState(null);

  const { input } = useField(name);

  const handleChange = (files) => {
    const file = files[0];
    input.onChange(file);
  };

  const handleRemove = () => {
    input.onChange(null);
    setPreviewError(null);
  };

  const handlePreviewError = () => {
    setPreviewError(true);
  };

  return (
    <WithLabel variant={LABEL_STYLES.ROW} label={label} isRequired={isRequired} isBold isTwoDots>
      <Field name={name} type='file'>
        {({ input, meta }) => (
          <WithError isShowError={meta.touched && meta.error} errorText={t(meta.error)} isAbsolute>
            <div className={scss.fileInputWrapper}>
              {!input.value ? (
                <DropZone
                  onDropFiles={handleChange}
                  accept={acceptedFileTypes}
                  multiple={false}
                  disabled={disabled}
                  className={scss.dropZoneWrapper}>
                  <input
                    name={input.name}
                    type='file'
                    id={`additional-file-input-${name}`}
                    accept={acceptedFileTypes}
                    className={scss.fileInput}
                    onChange={(e) => handleChange(e.target.files)}
                    onBlur={input.onBlur}
                    onFocus={input.onFocus}
                    disabled={disabled}
                  />
                  <label
                    htmlFor={`additional-file-input-${name}`}
                    data-disabled={disabled}
                    className={scss.fileLabel}
                    data-error={meta.touched && meta.error ? true : false}>
                    <Icon icon={ICONS.ImportIcon} />
                    {input.value?.name ?? label}
                  </label>
                </DropZone>
              ) : null}
              {!previewError ? (
                <ImagePreview image={input.value} onRemove={handleRemove} onError={handlePreviewError} />
              ) : null}
              {previewError ? <UploadedFileCard file={input.value} onRemove={handleRemove} name={name} /> : null}
            </div>
          </WithError>
        )}
      </Field>
    </WithLabel>
  );
}

export default FileInput;

const UploadedFileCard = ({ file, onRemove }) => {
  return (
    <>
      <label className={scss.fileLabel} data-disabled={true}>
        {file.name ?? '-/-'}
      </label>

      <button type='button' className={scss.clearFile} onClick={onRemove} aria-label='Clear file'>
        <Icon icon={ICONS.Cross} />
      </button>
    </>
  );
};
